import React from "react";
import { useRootElement } from "../context";
import * as styles from "./styles";
import { Text } from "~/components/deprecated/components/Text";

export const Legend = () => {
  const { labels, colors } = useRootElement();

  return (
    <ul className={styles.container}>
      {labels.map((label, index) => (
        <li key={label} className={styles.item}>
          <div
            className={styles.itemColor}
            // This is being used because the colors can be customized
            // and tailwind does not like string concatenation
            style={{
              backgroundColor: colors?.[index] || "#000",
            }}
          />
          <Text noMargin lineClamp={1} variant="caption1">
            {label}
          </Text>
        </li>
      ))}
    </ul>
  );
};
